//

import React from 'react'
import { Flex, SubMenuItems, useMatchBreakpoints } from '@pancakeswap/uikit'
import { getActiveMenuItem, getActiveSubMenuItem } from 'components/Menu/utils'
import menuConfig from 'components/Menu/config/config'
import { useTranslation } from 'contexts/Localization'
import { useLocation } from 'react-router-dom'

export default function SubHeaderBar() {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const { isMobile } = useMatchBreakpoints()
  const activeMenuItem = getActiveMenuItem({ menuConfig: menuConfig(t), pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const subLinksWithoutMobile = activeMenuItem?.items?.filter((subLink) => !subLink.isMobileOnly)
  const subLinksMobileOnly = activeMenuItem?.items?.filter((subLink) => subLink.isMobileOnly)

  if (!isMobile) return <></>
  if (!activeMenuItem?.items) return <></>
  return (
    <Flex justifyContent="space-around" style={{ width: '100%' }}>
      <SubMenuItems items={subLinksWithoutMobile} mt="30px" activeItem={activeSubMenuItem?.href} />
      {subLinksMobileOnly?.length > 0 && (
        <SubMenuItems items={subLinksMobileOnly} mt="30px" activeItem={activeSubMenuItem?.href} isMobileOnly />
      )}
    </Flex>
  )
}
